import React, { useEffect, useState } from 'react'

import { useWrapperContext } from 'components/Wrapper/Wrapper'
import { AnimatedForm, Form, FormFieldType } from 'shared/components'

import { transformFormType } from 'shared/pipes'
import { emailValidator } from 'shared/utils'

import { FormTypes } from 'models'

export const PartnersBlockFormId = 'partners-block-form'

const fields: FormFieldType[] = [
  {
    type: 'input',
    label: 'Фамилия',
    placeholder: 'Введите фамилию',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'surname',
    maxSize: 50,
    required: true,
  },
  {
    type: 'input',
    label: 'Имя',
    placeholder: 'Введите имя',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'name',
    maxSize: 50,
    required: true,
  },
  {
    type: 'input',
    label: 'Компания',
    placeholder: 'Введите название компании',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'company',
    required: true,
    maxSize: 50,
  },
  {
    type: 'input',
    placeholder: 'Введите email',
    label: 'E-mail для связи',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'email',
    validatorFn: emailValidator,
    required: true,
  },
  {
    type: 'textarea',
    placeholder: 'Введите описание запроса',
    label: 'Опишите кратко ваш запрос',
    colClasses: 'col-xs-12 col-sm-12 mb-2',
    name: 'message',
    maxSize: 1000,
    required: true,
  },
]

export const PartnersForm = (): JSX.Element => {
  const { formOpened, setFormOpened } = useWrapperContext()
  const [formTitle, setFormTitle] = useState('')
  const [isSubmit, setIsSubmit] = useState(false)

  useEffect(() => {
    if (formOpened) {
      setIsSubmit(false)
      setFormTitle(transformFormType(formOpened))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formOpened])

  useEffect(() => {
    setFormOpened(undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  const handleSubmit = () => {
    setIsSubmit(true)
  }

  const handleClose = () => {
    setIsSubmit(false)
    setFormOpened(undefined)
  }

  return (
    <AnimatedForm
      id={PartnersBlockFormId}
      open={!!formOpened}
      scrollCenter={isSubmit}
    >
      <Form
        showed={!!formOpened}
        id={PartnersBlockFormId}
        fields={fields}
        title={formTitle}
        showUserAgreement
        onCloseClick={() => handleClose()}
        onAutoClose={() => handleClose()}
        onSubmit={() => handleSubmit()}
        titleLarge
        type={formOpened || FormTypes.Inform}
      />
    </AnimatedForm>
  )
}
